import type { FaireProductEntity } from "../../entity_types/product";

export const p_gxe508j: FaireProductEntity = {
  token: "p_gxe508j",
  type: "product",
  name: "Sparkling Apple Juice",
  brandName: "Lovely Branch",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d3536a31a25a764ec8df300e640932116da4e34077e080660c443f76eb9994cf.webp",
  priceDollars: 7.5,
  description:
    "Juicy, extra tart, naturally sweet sparkling apple juice from Northeast apples",
  categoryTokens: ["cat_food-beverages"],
  tags: ["premium", "organic", "sparkling", "juice"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/d3536a31a25a764ec8df300e640932116da4e34077e080660c443f76eb9994cf.webp",
  weight: 0.7,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  inStock: true,
};
